export const defaultFilters = {
  searchString: '',
  byGroup: 'all',
  criteria: 'all',
  complianceLevel: 'all',
  severity: 'all',
  issueType: 'all',
};

export const groupByMap = [
  {
    label: 'groupByMap.ListByPage',
    value: 'all',
  },
  {
    label: 'groupByMap.ByPage',
    value: 'ByPage',
  },
  {
    label: 'groupByMap.ByCriteria',
    value: 'ByCriteria',
  },
  {
    label: 'groupByMap.ByComplianceLevel',
    value: 'ByComplianceLevel',
  },
  {
    label: 'groupByMap.ByPOUR',
    value: 'ByPour',
  },
];

export const criteriaMap = [
  {
    label: 'Criteria',
    value: 'all',
  },
  {
    label: '1.1.1',
    value: '1.1.1',
  },
  {
    label: '1.2.1',
    value: '1.2.1',
  },
  {
    label: '1.2.2',
    value: '1.2.2',
  },
  {
    label: '1.2.3',
    value: '1.2.3',
  },
  {
    label: '1.2.4',
    value: '1.2.4',
  },
  {
    label: '1.2.5',
    value: '1.2.5',
  },
  {
    label: '1.2.6',
    value: '1.2.6',
  },
  {
    label: '1.2.7',
    value: '1.2.7',
  },
  {
    label: '1.2.8',
    value: '1.2.8',
  },
  {
    label: '1.2.9',
    value: '1.2.9',
  },
  {
    label: '1.3.1',
    value: '1.3.1',
  },
  {
    label: '1.3.2',
    value: '1.3.2',
  },
  {
    label: '1.3.3',
    value: '1.3.3',
  },
  {
    label: '1.3.4',
    value: '1.3.4',
  },
  {
    label: '1.3.5',
    value: '1.3.5',
  },
  {
    label: '1.3.6',
    value: '1.3.6',
  },
  {
    label: '1.4.1',
    value: '1.4.1',
  },
  {
    label: '1.4.2',
    value: '1.4.2',
  },
  {
    label: '1.4.3',
    value: '1.4.3',
  },
  {
    label: '1.4.4',
    value: '1.4.4',
  },
  {
    label: '1.4.5',
    value: '1.4.5',
  },
  {
    label: '1.4.6',
    value: '1.4.6',
  },
  {
    label: '1.4.7',
    value: '1.4.7',
  },
  {
    label: '1.4.8',
    value: '1.4.8',
  },
  {
    label: '1.4.9',
    value: '1.4.9',
  },
  {
    label: '1.4.10',
    value: '1.4.10',
  },
  {
    label: '1.4.11',
    value: '1.4.11',
  },
  {
    label: '1.4.12',
    value: '1.4.12',
  },
  {
    label: '1.4.13',
    value: '1.4.13',
  },
  {
    label: '2.1.1',
    value: '2.1.1',
  },
  {
    label: '2.1.2',
    value: '2.1.2',
  },
  {
    label: '2.1.3',
    value: '2.1.3',
  },
  {
    label: '2.1.4',
    value: '2.1.4',
  },
  {
    label: '2.2.1',
    value: '2.2.1',
  },
  {
    label: '2.2.2',
    value: '2.2.2',
  },
  {
    label: '2.2.3',
    value: '2.2.3',
  },
  {
    label: '2.2.4',
    value: '2.2.4',
  },
  {
    label: '2.2.5',
    value: '2.2.5',
  },
  {
    label: '2.2.6',
    value: '2.2.6',
  },
  {
    label: '2.3.1',
    value: '2.3.1',
  },
  {
    label: '2.3.2',
    value: '2.3.2',
  },
  {
    label: '2.3.3',
    value: '2.3.3',
  },
  {
    label: '2.4.1',
    value: '2.4.1',
  },
  {
    label: '2.4.2',
    value: '2.4.2',
  },
  {
    label: '2.4.3',
    value: '2.4.3',
  },
  {
    label: '2.4.4',
    value: '2.4.4',
  },
  {
    label: '2.4.5',
    value: '2.4.5',
  },
  {
    label: '2.4.6',
    value: '2.4.6',
  },
  {
    label: '2.4.7',
    value: '2.4.7',
  },
  {
    label: '2.4.8',
    value: '2.4.8',
  },
  {
    label: '2.4.9',
    value: '2.4.9',
  },
  {
    label: '2.4.10',
    value: '2.4.10',
  },
  {
    label: '2.5.1',
    value: '2.5.1',
  },
  {
    label: '2.5.2',
    value: '2.5.2',
  },
  {
    label: '2.5.3',
    value: '2.5.3',
  },
  {
    label: '2.5.4',
    value: '2.5.4',
  },
  {
    label: '2.5.5',
    value: '2.5.5',
  },
  {
    label: '2.5.6',
    value: '2.5.6',
  },
  {
    label: '3.1.1',
    value: '3.1.1',
  },
  {
    label: '3.1.2',
    value: '3.1.2',
  },
  {
    label: '3.1.3',
    value: '3.1.3',
  },
  {
    label: '3.1.4',
    value: '3.1.4',
  },
  {
    label: '3.1.5',
    value: '3.1.5',
  },
  {
    label: '3.1.6',
    value: '3.1.6',
  },
  {
    label: '3.2.1',
    value: '3.2.1',
  },
  {
    label: '3.2.2',
    value: '3.2.2',
  },
  {
    label: '3.2.3',
    value: '3.2.3',
  },
  {
    label: '3.2.4',
    value: '3.2.4',
  },
  {
    label: '3.2.5',
    value: '3.2.5',
  },
  {
    label: '3.3.1',
    value: '3.3.1',
  },
  {
    label: '3.3.2',
    value: '3.3.2',
  },
  {
    label: '3.3.3',
    value: '3.3.3',
  },
  {
    label: '3.3.4',
    value: '3.3.4',
  },
  {
    label: '3.3.5',
    value: '3.3.5',
  },
  {
    label: '3.3.6',
    value: '3.3.6',
  },
  {
    label: '4.1.1',
    value: '4.1.1',
  },
  {
    label: '4.1.2',
    value: '4.1.2',
  },
  {
    label: '4.1.3',
    value: '4.1.3',
  },
];

export const complianceLevelMap = [
  {
    label: 'LevelDefault',
    value: 'all',
  },
  {
    label: 'AAA',
    value: 'AAA',
  },
  {
    label: 'AA',
    value: 'AA',
  },
  {
    label: 'A',
    value: 'A',
  },
];

export const issuesPrior = [
  {
    label: 'Severity',
    value: 'all',
  },
  {
    label: 'issuesBySeverity.Critical',
    value: 'critical',
  },
  {
    label: 'issuesBySeverity.High',
    value: 'high',
  },
  {
    label: 'issuesBySeverity.Medium',
    value: 'medium',
  },
  {
    label: 'issuesBySeverity.Low',
    value: 'low',
  },
  {
    label: 'issuesBySeverity.Warning',
    value: 'warning',
  },
];

export const issuesPour = [
  {
    label: 'issuesByPOUR.type',
    value: 'all',
  },
  {
    label: 'issuesByPOUR.Perceivable',
    value: 'Perceivable',
  },
  {
    label: 'issuesByPOUR.Operable',
    value: 'Operable',
  },
  {
    label: 'issuesByPOUR.Understandable',
    value: 'Understandable',
  },
  {
    label: 'issuesByPOUR.Robust',
    value: 'Robust',
  },
];
